import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetLcrWorksheets = (crId, lcrId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['lcrWorksheets', crId, lcrId],
    () => axiosInstance.get(liveCleanroom(orgId)
      .getLcrWorksheets(crId, lcrId)),
    {
      select: (response) => response.data?.liveCleanRoomWorksheets,
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message || 'Error fetching LCR worksheets',
          type: 'error',
        }));
      },
    },
  );
};
